import DomainPage from "@/pages/solutions/DomainPage";

const config = {
  slug: "aging-disability",
  name: "Disability, Aging & Continuing Care",
  ctaName: "disability, aging & continuing care",
  h1: "Which communities are hitting the demographic tipping point without the beds to match?",
  lede:
    "Aging populations are mapped against continuing-care beds, home-care hours, and waitlists community by community — so a region can see the gap forming before it becomes a crisis, not after. Continuum's third domain turns the census data your HNA already ingested into seniors', disability, and continuing-care intelligence.",
  problem: [
    "Seniors' services planning today runs on census projections and whatever bed counts a regional health authority will share. It rarely asks the harder question: given where the 75+ population is actually growing, where will continuing-care capacity and home-care hours fall short first?",
    "This domain layers population-aging trajectories over bed inventories, home-care capacity, and waitlist data — the same place-based method already proven on housing need. The context is already asking for it: provincial continuing-care standards, CIHI long-term care data, federal New Horizons for Seniors funding, and municipal seniors' strategies.",
  ],
  evidenceBase: {
    heading: "The demographic layer,",
    headingAccent: "not a separate study.",
    body:
      "Population aging is a slow-moving, highly predictable signal — which makes it exactly the kind of indicator a persistent evidence base handles better than a one-time study. This is also the cheapest domain to stand up: it reuses the census age-band and demographic data already ingested for the HNA evidence base. Tenants get demographic trajectories refreshed automatically, layered against whatever capacity data a region shares.",
  },
  produces: [
    "Aging & continuing-care profile — trajectory vs. capacity",
    "Bed & home-care waitlist monitor",
    "Tipping-point flagging for regional planners",
  ],
  pricingNote:
    "The full module catalog publishes as data sources are confirmed — the honesty architecture applies to the roadmap too.",
  pricingRows: [
    {
      product: "Seniors & Continuing Care Profile",
      status: "PLANNED",
      who: "Regional health authorities, municipalities, seniors coalitions",
      model: "Setup + annual refresh",
      price: "$8k–14k + $4k/yr",
    },
  ],
  faq: [
    {
      q: "When does this domain launch?",
      a: "No fixed date yet. Waitlist members get module releases, methodology drops, and pricing decisions as they're made — before general announcement.",
    },
    {
      q: "Do we need the housing module first?",
      a: "No. This domain will run standalone. Tenants already on housing get the shared evidence base included, since the census age-band and demographic data overlap directly.",
    },
  ],
};

export default function AgingDisabilityDomain() {
  return <DomainPage config={config} />;
}
